import axios from "axios";
import { CONST } from "../config/const";

export async function postCancell(
  display: string,
  pathName: string,
  customer_info: { [key: string]: string | string[] }
) {
  try {
    const path = "cancell";
    const bodys = {
      display,
      pathName,
      customer_info,
    };
    const response = await axios.post(CONST.cancellApiUrl + path, {
      bodys,
    });
    const result: string = response.data.add;
    return result;
  } catch (error) {
    // logout();
    return "";
  }
}
